import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { PropertiesService } from 'src/app/properties/service/properties.service';

@Component({
  selector: 'app-capture',
  templateUrl: './capture.component.html',
  styleUrls: ['./capture.component.scss']
})
export class CaptureComponent implements OnInit {

  @ViewChild('locacao', { static: true }) locacao: ElementRef;
  @ViewChild('unidade', { static: true }) unidade: ElementRef;
  @ViewChild('venda', { static: true }) venda: ElementRef;

  public formRegistry: FormGroup;
  public formSaleRent: FormGroup;
  public formUser: FormGroup;
  private docBody = document.querySelector('body');

  constructor(
    private formBuilder: FormBuilder,
    private service: PropertiesService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.docBody.setAttribute('style', 'overflow: auto');
    this.initializeForm();
    // this.formRegistry.patchValue(JSON.parse(localStorage.getItem('form')));
  }

  // // FORMS
  private initializeForm() {
    this.formRegistry = this.formBuilder.group({
      id: [null],
      typeCode: [3],
      zip_code: [null],
      street: ['Avenida Professor Luiz Ignácio Anhaia Mello'],
      country: [''],
      number: ['627'],
      complement: [null],
      neighborhood: ['Jardim América'],
      state: ['SP'],
      city: ['Vila Bela da Santíssima Trindade'],
      value_zone: [null],
      location_value_zones: [null],
      geographic_area: [null],
      condominium: ['Penha Plano Manoel Leiroz de Azevedo'],
      area_util: [null],
      areat_total: [null],
      single_tower: [false],
      number_name_tower: [null],
      floor: [null],
      unity: [null],
      not_number: [false]
    });
    this.formSaleRent = this.formBuilder.group({
      sale: [ false ],
      salePrice: [ null, [ Validators.required ] ],
      commission: [ null ],
      settled: [ true ],
      notSettled: [ null ],
      debt: [ null ],
      profitable: [ false ],
      notProfitable: [ true ],
      income: [ null ],
      saleD1: [ false ],
      saleD2: [ false ],
      saleD3: [ false ],
      saleD4: [ false ],
      saleResponsible: [ null ],
      rent: [ false ],
      rentPrice: [ null, [ Validators.required ] ],
      rentD1: [ null ],
      rentD2: [ null ],
      rentD3: [ null ],
      rentResponsible: [ null ]
    });
    this.formUser = this.formBuilder.group({
      users: []
    });
  }

  public getFormLocation(event: FormGroup): void {
    for (const key in event) {
      if (event.hasOwnProperty(key)) {
        this.formRegistry.get(key).patchValue(event[key]);
      }
    }
  }

  public sendFormRegistry() {
    this.service.validatorForm(this.formRegistry);
  }

  public routerBack() {
    this.router.navigate(['/produtos'], { relativeTo: this.route });
  }

  public sendValue(event) {
    this.formUser.get('users').setValue(event);
  }

}